"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Top = function Top(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%',
      // maxWidth: '900px',
      margin: 0,
      marginLeft: 'auto',
      marginRight: 'auto',
      padding: 0,
      boxShadow: '0px -1px 6px 2px rgba(0,0,0,0.5)',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flex: '1',
      zIndex: 99999
    }
  }, children);
};

var _default = Top;
exports["default"] = _default;